<template lang="pug">
shListData(title="Artículos Predeterminados" resolver="articleDefaults" keyData="articleDefault" component="shArticleDefault")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'ArticleDefaults',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/articleDefault/ArticleDefaults.vue